import { render, staticRenderFns } from "./RolesEdition.vue?vue&type=template&id=164171ca&"
import script from "./RolesEdition.vue?vue&type=script&lang=js&"
export * from "./RolesEdition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports